export default __webpack_public_path__ + "static/media/Bar.e16950a5.svg";